const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines Beta icon
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Events the resource defined to get and set Events data
 */
app.directive('betaIcon', ['Application', function(Application) {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    template: require('../../templates/directives/beta-icon.html'),
    controller: ['$scope', function($scope) {
      var self = this;
      self.iconColor = Application.colors.get()[0];
      }],
    controllerAs: 'betaIcon'
  };
}]);
